import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ShimmerLoaderComponent } from "../shimmer-loader/shimmer-loader.component";
import { DataUnavailableComponent } from '../../Pages/common/data-unavailable/data-unavailable.component';
import { HttpService } from '../../Services/http';

interface ContactInfoJsonBlockDataItem {
  header?: string;
  headerSize?: string;
  position?: number;
  paragraph?: string[];
  listType?: string;
  items?: string[];
}
interface ContactInfoComponentEntry {
  type: string;
  position: number;
  data: ContactInfoJsonBlockDataItem[];
}
interface ContactInfoGroup {
  group: string;
  position: number;
  components: ContactInfoComponentEntry[];
}
interface ContactInfoOverviewSection {
  route: string;
  section: string;
  tab: string;
  tax_type: string;
  components: ContactInfoGroup[];
}
interface ContactInfoJson {
  pageName: string;
  sideMenu: any[];
  menuContent: { overview: ContactInfoOverviewSection };
}

@Component({
  selector: 'app-contact-information',
  imports: [CommonModule, ShimmerLoaderComponent, DataUnavailableComponent],
  templateUrl: './contact-information.component.html',
  styleUrl: './contact-information.component.scss'
})

export class ContactInformationComponent implements OnInit {
  data?: ContactInfoJson;
  blocks: ContactInfoComponentEntry[] = [];
  loading = true;
  error = '';

  // Derived convenience getters for template (avoid complex expressions inline)
  get addressBlocks(): ContactInfoComponentEntry[] { return this.blocks.filter(b => b.position === 2); }
  get emailBlocks(): ContactInfoComponentEntry[] { return this.blocks.filter(b => b.position === 3); }
  get telephoneHeaderBlocks(): ContactInfoComponentEntry[] { return this.blocks.filter(b => b.position === 4); }
  get listBlocks(): ContactInfoComponentEntry[] { return this.blocks.filter(b => b.type === 'list'); }

  constructor(private httpService: HttpService, @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    console.log("In contact")
    if (!isPlatformBrowser(this.platformId)) {
      this.loading = false;
      return;
    }
    this.fetch();
  }

  private async fetch(): Promise<void> {
    this.loading = true;
    try {
      const result = await this.httpService.getJsonData('JSONData/footer/contact-info.json', '');
      if (result?.status === 200) {
        const json = result.response;
        this.data = json;
        const overview = json.menuContent?.overview;
        const groups = overview?.components || [];
        this.blocks = groups.flatMap((g: any) => g.components).sort((a: any, b: any) => a.position - b.position);
        this.loading = false;
        this.cdr.markForCheck();
      } else {
        this.error = 'Unable to load contact information.';
        this.loading = false;
        this.cdr.markForCheck();
      }
    } catch (err) {
      console.error('Failed to load contact-info JSON', err);
      this.error = 'Unable to load contact information.';
      this.loading = false;
      this.cdr.markForCheck();
    }
  }
}
